import {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import Button from 'components/Button';
import DateSelectContext from '../../context';

const ButtonClear = () => {
    const {onChange, required} = useContext(DateSelectContext);
    const {t} = useTranslation();

    if (required) return null;

    const onClick = () => onChange(undefined);

    return (
        <Button className="w-full" kind="tertiary" onClick={onClick} size="sm">
            {t('form:clear')}
        </Button>
    );
};

export default ButtonClear;
